import { Controller } from "@hotwired/stimulus"
import type { Dropdown } from "bootstrap"

export default class FilterDropdownController extends Controller {
  static targets = ["toggle"]

  declare toggleTarget: HTMLElement
  declare hasToggleTarget: boolean

  close(): void {
    if (!this.hasToggleTarget) return

    const dropdown =
      (globalThis.bootstrap.Dropdown.getInstance(this.toggleTarget) as Dropdown | null) ??
      new globalThis.bootstrap.Dropdown(this.toggleTarget)
    dropdown.hide()
  }
}
